export default {
  // Login Screen
  LOGIN: 'Login',
  KIOSK_LOGIN: 'LOGIN',
  ACTIVATE_INGENICO_DEVICE: 'ACTIVE INGENICO DEVICE',
  CANCEL: 'Cancel',
  KIOSK_CANCEL: 'CANCEL',
  CONTACT: 'contact',
  FOR_SUPPORT: 'For support',
  CLICK_TO_SWIPE_CARD: 'CLICK TO SWIPE',
  SWIPE_CARD_CANCEL: 'CANCEL',
  //CARD_READER_CHECKING_CONNECTION: 'Checking card reader connection...',
  CARD_READER_CHECKING_CONNECTION: '',
  CARD_READER_RECONNECTING_ATTEMPT: 'Card reader not connected. Attempting reconnect {attempt} of {total}...',
  CARD_READER_NOT_READY_GENERIC: 'Card reader is not ready. Please check the connection and try again.',
  LOGIN_CARD_READER_WARNING: 'The payment card reader is not responding. You may continue using the tablet for ordering only. Reset the card reader if you need to take payment.',
  CONTINUE_TO_ORDERING: 'Continue to Ordering',
  CARD_READER_PAY_PREVENTION_ERROR: 'The payment card reader is not responding. You cannot take payment on this device until it is reset. Reset card reader or use a different tablet.',

  // Check Listing Screen
  TABLE: 'Table',
  CHECKS: 'Check#',
  TAB: 'Tab',
  OTHER: 'Other',
  OPEN_SCAN: 'Scan',
  OPEN_TABLE: 'Table',
  OPEN_TAB: 'Tab',
  OPEN_OTHER: 'Other',
  ALL_CHECKS: 'All Checks',
  OPEN_CHECKS: 'Open Checks',
  LOYALTY_ACCOUNT_BALANCE: 'Loyalty Account Balance',
  LOYALTY_BALANCE: 'Loyalty Balance',
  MY_TIPS: 'My Tips',
  PAIR_WATCH: 'Pair Watch',
  ABOUT: 'About',
  ABOUT_CLOSE: 'Close',
  PAIR: 'Pair',
  SYNC_CHECKS: 'Sync Checks',
  CHANGE_JOB: 'Change Job Type',
  SENT: 'Sent',
  PENDING: 'Pending',
  ORDER: 'Order',
  PRINT: 'Print',
  EDIT_TIP_PERCENTAGE: 'Edit Tip Percentage',
  ADD_PHONE_NUMBER: 'Add Phone Number',
  ADD: 'Add Seat',
  ADD_SEAT_QR_ORDER: 'Add',
  ACKNOWLEDGED: 'Acknowledged',
  DISMISS: 'Dismiss',
  NOTIFICATIONS: 'Notifications',
  CLS_LOGOUT: 'Logout',
  TIP_ONLY: 'Tip Only',
  // OPEN_TOGO : 'To Go',
  HAMBURGER_OFFLINE_PAYMENT: 'Offline Payment',
  OFFLINE_CANCEL: "Cancel",
  OFFLINE_PAY: "Pay",
  OFFLINE_ENTER_NAME: "Enter Name",
  OFFLINE_ENTER_CHECK_NUMBER: "Enter Check Number",
  OFFLINE_ENTER_SUBTOTAL: "Enter Subtotal",
  OFFLINE_ENTER_TAX: "Enter Tax",
  OFFLINE_PLEASE_ENTER_NAME: "Please enter name",
  OFFLINE_PLEASE_ENTER_CHECK_NUMBER: "Please enter check number",
  OFFLINE_PLEASE_ENTER_SUBTOTAL_AMOUNT: "Please enter subtotal amount",
  OFFLINE_PLEASE_ENTER_TAX_AMOUNT: "Please enter tax amount",


  // EDIT_SEATS: 'Edit Seats',
  TABLE_QUANTITY: 'Qty',
  TABLE_ITEM: 'Items',
  TABLE_SEAT: 'Seat',
  TABLE_SENTAT: 'Sent at',
  TABLE_AMOUNT: 'Amount',
  STAGE: 'Stage',
  PRE_AUTH: 'Pre Auth',
  PAY: 'Pay',
  PAY_NOW: 'Pay Now',
  RECEIPT: 'Receipt',
  TOOLS: 'More',
  SELECT_CARD: 'Select a card',
  REPOST_SELECT_CARD: 'Select a card to repost',
  CARD_TYPE_NAME: 'Card Type',
  CARD: 'Card #',
  HOLDER_NAME: 'Card Holder Name',
  SELECT_BTN: 'Select',
  SELECT: 'Select',
  GC_SWIPE_RECEIPT: "Swipe",
  BUSINESS_DATE: 'Business Date:',
  CHECK: 'Check #:',
  SERVER: 'Server:',
  PRE_TOTAL_AMOUNT: 'Total Amount',
  PRE_PAID_AMOUNT: 'Paid Amount:',
  PRE_UNPAID_AMOUNT: 'Unpaid Amount:',
  PRE_DUE_AMOUNT: 'Due Amount:',
  DELETE: 'Delete',
  DELETE_ALL: 'Delete All',
  SEND_ALL: 'Send All',
  EDIT: 'Edit',
  ENABLE_RESTRICTED: 'Enable Restricted',
  DISABLE_RESTRICTED: 'Disable Restricted',
  MOVE: 'Move',
  SEND: 'Send',
  SEARCH: 'Search',
  NO: 'No',
  PARTIAL_PAYMENT_NO: 'NO',
  PARTIAL_PAYMENT_YES: 'YES',
  KIOSK_NO: 'NO',
  YES: 'Yes',
  KIOSK_YES: 'YES',
  OPEN: 'Open',
  GUEST_COUNT: 'Guest Count',
  NO_CHECKS: 'No Checks',
  REPEAT: 'Repeat',
  SELECT_JOB: 'Select Job',
  OFF_PREMISE_ORDERS: 'Off Premise Orders',
  PHONE_NUMBER: 'Phone Number',
  GUEST_NAME: 'Guest Name',
  PICKUP_TIME: 'Pickup time',
  DELIVERY_TIME: 'Delivery Time',
  CALL_IN: 'Call In',
  ADDRESS_1: 'Address 1',
  ADDRESS_2: 'Address 2',
  CITY: 'City',
  STATE: 'State',
  ZIP: 'Zip',
  SYNC_CHECKS_WITH_POS: 'Sync Check With POS',
  SEND_QR_LINK: 'Send QR Link',
  PRINT_TABLE_QR: 'Print Table QR',
  REPOST_PAYMENT: 'Repost Payment',
  PRE_AUTH_PAYMENT: 'Complete Pre Auth Payment',
  PRINT_RECEIPT_LABEL:'Print Receipt',
  SUBMIT: 'Submit',
  KIOSK_SUBMIT: 'SUBMIT',
  SAVE: 'Save',
  EMAIL: 'Email',
  TEXT: 'Text',
  VOID: 'Void',
  EMP: 'Emp',
  TIME: 'Time',
  PAID: 'Paid',
  TAKE_OUT: 'Walk Up',
  SELECT_EMPLOYEE: 'Select Employee',
  SELECT_AN_EMPLOYEE: 'Select an Employee',
  SELECT_TABLE: 'Select a Table',
  EMPLOYEE: 'Employee',
  UPDATE_CHECK_NAME: 'Update Check Name',
  SELECT_EMP: 'Select Employee',
  NAME: 'Name',
  CHANGE_ORIENTATION: 'Screen Orientation',
  JOB_TYPE: 'Job type',
  SELECT_ORIENTATION: 'Select Screen Orientation',
  LEFT: 'Left',
  RIGHT: 'Right',
  SPLIT: 'Split',
  //CheckListing Header lables
  CHECK_LISTING_TABLE_NUMBER: 'Table',
  CHECK_LISTING_CHECK_NUMBER: 'Check#',
  CHECK_LISTING_OWNER: 'Owner',
  CHECK_LISTING_PAID: 'Paid',
  CHECK_LISTING_DUE: 'Due',
  CHECK_LISTING_TIME: 'Time',

  CHECK_LISTING_TOTAL: 'Total',
  LAUNCH_EXTERNAL_APP: 'Launch External App',
  TOGGLE_TEAM_CHECKS: 'Team Checks',
  TOGGLE_MY_CHECKS: 'My Checks',
  TOTAL_REMAINING: 'Total Remaining',
  SEND_SMS: 'Send SMS',
  SENDSMS: 'Send SMS',
  TABLE_TRANSFER: 'Transfer Table',
  REASSIGN_EMPLOYEE: 'Reassign Employee',
  REMOVE: 'REMOVE',
  TAX_EXEMPT: 'Tax Exempt',
  // Order Screen

  CLEAR: 'Clear',
  APPLY: 'Apply',
  DISCOUNT: 'Discount',
  DISCOUNT_OPEN: 'Discount Open',
  DUE: 'Due',
  VIEW: 'View',
  MODIFY_ITEM: 'MODIFY ITEM',
  OCCUPY_SEAT: 'Occupy Seat',
  SEAT: 'SEAT',
  SEATS: 'SEATS',
  OK: 'OK',
  MERGE_OK: 'OK',
  REFILL_REMOVE: 'REMOVE',
  TRANSFER: 'Transfer',
  TRANSFER_EMPLOYEE: 'Transfer Employee',
  TABLE_MERGE: 'Table Merge',
  DELETE_DISCOUNT: 'Delete',
  TRANSFER_TABLE: 'Transfer Table',
  VOID_CHECK: 'Void Check',
  VOID_ITEM: 'Void Item',
  KEEP_OPEN: 'Keep Open',
  RETRY_: 'Retry',
  MERGE_CHECK: 'Merge Check',
  GAME_CARDS: 'Game Card',
  RETRY: 'Retry',
  ORDER_NOW: 'Order Now',
  CHECKOUT: 'CHECKOUT',
  SEND_NOW: 'Send now',
  CART: 'Cart',
  CLOSE: 'CLOSE',
  KIOSK_CLOSE: 'CLOSE',
  SMS: 'Text Receipt',
  TOGO: 'To-Go',
  ON_THE_FLY: 'On the fly',
  RUNNER: 'Runner',
  DO_NOT_MAKE: 'Do not make',
  RESTART_ORDER: 'Restart Order',
  MORE_INFO: 'MORE INFO',
  TBL: 'TBL',
  NEW_CHECK: 'Start New Check',
  GO_TO_CHECK: 'Go To Check',
  SEND_ORDER: 'SEND ORDER',
  OPEN_DOLLAR_ITEM: 'Open Dollar Item',
  SELECT_A_SEAT_TO_DELETE: 'Select a seat to delete',
  DELETE_SEAT: 'Delete Seat',
  ADD_SEAT: 'Add Seat',
  REMOVE_MOD: 'Remove',
  DONE_MOD: 'Done',
  OS_CLOSE: "Close",
  OTHERS: 'Others',
  MODIFY: 'Modify',
  // Order details

  ADD_TO_CART: 'Add to Cart',
  UPDATE_CART: 'Update Cart',
  UPDATE_ORDER: 'Update Order',
  SPECIAL_INSTRUCTIONS: 'Special Instructions',
  ADD_TO_BAG: 'Add to Bag',
  ADD_A_NOTE: 'Add a Note',
  ADDITIONAL_TIME: 'Additional Time',
  VIEW_ONLY: 'View Only',
  SPECIAL: 'Special',
  ORDER_ANOTHER: 'ORDER ANOTHER',
  COMING_SOON: 'Coming soon',
  LIMITED_QUANTITY: 'Limited quantity',
  TIME_RESTRICTED: 'Time restricted',
  FEATURED: 'Featured',
  OUT_OF_STOCK: 'Out of Stock',
  LIMITED_TIME: 'Limited Time',
  NEW_ITEM: 'New Item',
  OUT_OF_STOCK_NUMBER: '86',
  ITEM_FACTS: 'Item Facts',
  NUTRITION_FACT: 'Nutrition Facts',
  VIEW_LARGE_IMAGE: 'View Large Image',
  SELECT_ANOTHER_TABLE: "Select Another Table",
  SELECT_ANOTHER_TAB: "Select Another Tab",
  ORDER_DETAILS_CANCEL: "Cancel",

  // STAGE

  GOING_DUTCH: 'Going Dutch',
  CLEAR_ALL: 'Clear All',
  Edit_seat: 'Edit Seats',
  NO_STAGES: 'No stages',
  ALL_STAGES: 'All Stages',
  STAGE_PAY: 'PAY',

  // Payment Screen

  DONE: 'DONE',
  SUB_TOTAL: 'Subtotal',
  TAX: 'Tax',
  VAT: 'VAT',
  PAYMENT: 'Payment',
  DELIVERY: 'Delivery',
  PAY_AN_AMOUNT: 'Pay An Amount',
  SPLIT_EVENLY: 'Split Evenly',
  PAYMENT_COMPLETED: 'PAYMENT COMPLETED',
  PAYMENT_COMPLETED_VIA: 'PAYMENT IS NOW COMPLETE. Paid with',
  PAYMENT_FAILED: 'PAYMENT FAILED',
  CURRENCY_SYMBOL: '$',
  PERCENTAGE_SYMBOL: '%',
  PAY_PRINT_RECEIPT: 'PRINT RECEIPT',
  PAY_TEXT_RECEIPT: 'TEXT RECEIPT',
  PAY_EMAIL_RECEIPT: 'EMAIL RECEIPT',
  CONTINUE: 'Continue',
  CONTINUE_TO_GUEST: 'Continue To Next Guest',
  KIOSK_CONTINUE: 'CONTINUE',
  CC_CONTINUE: 'Continue',
  SKIP_SURVEY: 'SKIP SURVEY',
  ENTER_MOBILE_NUMBER: 'Enter Mobile Number',
  ENTER_ACCOUNT_NUMBER: 'Enter Account Number',
  ENTER_EMAIL_ADDRESS: 'Enter your email address',
  ENTER_TABLE_NAME: 'Enter Table Name',
  PAY_FULL_CHECK: 'Pay Full Check',
  CASH: 'Cash',
  KIOSK_CASH: 'CASH',
  TEXT_TO_PAY: 'Text To Pay',
  CREDIT_CARD: 'Credit card',
  KIOSK_CREDIT_CARD: 'CREDIT CARD',
  DEBIT_CARD: 'Debit Card',
  UNPAID: 'UNPAID',
  PRICE_CHECK: 'Price Check',
  CONFIRM: 'Confirm',
  PAYEMENT_TOTAL_DUE: 'Total Due',
  PAYMENT_TOTAL: 'Total',
  PAYMENTS: 'Payments',
  SERVICE_CHARGE: 'Service Charge',
  DISCOUNT_AMOUNT: 'Discount',
  PERCENT: 'PERCENT',
  PAY_REMAINING_BALANCE: 'Pay Balance',
  PAY_CHECK: 'Pay Check',
  TOTAL_PAID: 'Total paid',
  GIFT_BALANCE: 'Gift Card Balance',
  GAME_CARD_BALANCE :'Game Card Balance',
  BACK_TO_CHECKLIST : 'Back To Check List',
  GIFT_CARDS: 'Gift Card',
  SIGNATURE: 'Signature',
  SWIPE_CARD: 'CLICK TO SWIPE CARD',
  HAMBERGER_GIFTCARD_SWIPE: 'Click To Swipe Card',
  HAMBURGER_GIFTCARD_BALANCE: 'Get Balance',
  CLICK_TYPE: 'Click to type',
  CHECK_BALANCE: 'Check balance',
  TIPS: 'Tips',
  PAID_TIPS: 'Paid Tip',
  UNPAID_TIPS: 'Unpaid Tip',
  DISCOUNTS: 'Discounts',
  LOCATION: 'Location',
  PREVIOUS: 'PREVIOUS',
  NEXT: 'NEXT',
  PAYMENT_RECEIPT: 'PLEASE SELECT A RECEIPT OPTION',
  ENTER_TIP: 'ENTER TIP',
  INFORMATION: 'Information',
  EMPLOYEE_LOGIN: 'Employee Login',
  CALL_SERVER: 'Call Server',
  OTHER_OPTIONS: 'Other Options',
  OPT_IN: 'Opt In',
  CREDIT_CARD_OR_CONTACTLESS: 'CREDIT CARD OR CONTACTLESS',
  PAYMENT_NOW_COMPLETE: 'YOUR PAYMENT IS NOW COMPLETE.',
  CASH_PAYMENT: 'Cash',
  TOTAL_PAYMENT_PAID: 'TOTAL PAID',
  TOTAL_DUE_PAYMENT: 'TOTAL DUE',
  NO_RECEIPT_OPTION: 'NO RECEIPT',
  RECEIPT_TEXT_IT_TO_ME: 'TEXT IT TO ME',
  RECEIPT_EMAIL_IT_TO_ME: 'EMAIL IT TO ME',
  GO_TO_RECEIPT: 'Go To Receipt',
  CONFIRM_ID_CHECK: 'Confirm Id Check',
  CLEAR_ID_CHECK: 'Clear Id Check',
  EXTERNALCREDIT_CARD: 'External Credit Card',
  ENABLE_AGE_RESTRICTED: 'Enable Age Restricted Items',
  DISABLE_AGE_RESTRICTED: 'Disable Age Restricted Items',
  PREAUTH_CARD: 'CLICK TO PAY',
  BALANCE: 'Balance',
  APPLIED: 'Applied',
  TOTAL: 'Total',
  ITEMIZED: 'Itemized',
  APPROVED: 'Approved',
  YOU_ARE_ALL_DONE: `You're all done!`,
  NEED_A_RECEIPT: 'Need a Receipt?',
  NO_RECEIPT: 'No Receipt',
  // LOYALTY
  JOIN_NOW: 'Join Now',
  ACCOUNT_NUMBER: 'Account Number',
  ALREADY_A_MEMBER: 'Already a Member',
  NOT_NOW: 'Not Now',
  AVAILABLE_OFFERS: 'Available offers',
  NO_OFFERS: 'No offers available',
  QR_CODE: 'QR code',
  SKIP_OFFER: 'Skip Offer',
  APPLY_OFFER: 'Apply Offer',
  USE_COUPON: 'Use Coupon',
  COUPON_CANCEL: 'Cancel',
  APPLY_CODE: 'Apply Code',
  LOYALTY_PHONE_NUMBER: 'Phone Number',
  LOYALTY_EMAIL: 'Email',
  LOYALTY_ACCOUNT: 'Account',
  POINTS: 'Points',
  TIER: 'Tier',
  LOYALTY_SWIPE: 'SWIPE',
  LOYALTY_SCAN: 'SCAN',
  LOYALTY_PHONE_PLACEHOLDER: 'Enter Phone Number',
  LOYALTY_ACCOUNT_PLACEHOLDER: 'Enter Account Number',
  LOYALTY_EMAIL_PLACEHOLDER: 'Enter email-id',
  SIGN_IN_TO_LOYALTY: 'SIGN IN TO LOYALTY',
  SIGN_UP_TO_LOYALTY: 'SIGN UP TO LOYALTY',

  // OFFERS SCREEN
  OS_DUE: 'DUE',
  OS_ITEMIZED_CHECK: 'ITEMIZED CHECK',
  OS_SIGN_IN_TO_LOYALTY: 'SIGN IN TO LOYALTY',
  OS_OFFER: 'Offer',
  OS_NO_OFFERS: 'NO OFFERS',
  OS_VIEW_OFFERS: 'VIEW OFFERS',
  OS_USE_A_COUPON: 'USE A COUPON',
  OS_COUPON: 'Coupon',
  OS_ADD_A_GIFT_CARD: 'ADD A GIFT CARD',
  OS_ADD_ANOTHER_GIFT_CARD: 'ADD ANOTHER GIFT CARD',
  OS_BALANCE: 'Balance',
  OS_REDEEMED: 'Redeemed',
  OS_CARD_READY:
    'PLEASE HAVE YOUR CARD READY BEFORE YOU PROCEED. CLICK THE PAY BUTTON, WHEN READY.',
  OS_PAY_WITH_CASH_OR_MULTIPLE_CARDS: 'PAY WITH CASH OR MULTIPLE CARDS',
  OS_PAY_WITH_CARD: 'PAY WITH CARD',
  OS_COMPLETE_PAYMENT: 'COMPLETE PAYMENT',
  OS_LOYALTY: "Loyalty",

  // Date Format
  DATE_FORMAT_LONG: 'MM/DD/YYYY',
  DATE_FORMAT_SHORT: 'MM/DD/YY',
  DATE_FORMAT: 'YYYY-MM-DD',
  DATE_FORMAT_UK_LONG: 'DD/MM/YYYY',

  // Kiosk
  KIOSK_OK: 'OK',
  SHOW_MORE: 'show more',
  SHOW_LESS: 'show less',
  KIOSK_CUSTOM_AMOUNT: 'CUSTOM AMOUNT',
  KIOSK_CUSTOM_PERCENT: 'CUSTOM PERCENT',
  BACK_TO_CART: 'BACK TO CART',
  CONTINUE_ORDER: 'CONTINUE ORDER',
  START_OVER: 'START OVER',
  START_ORDER: 'Start order',
  KIOSK_START_ORDER: 'START ORDER',
  PAY_AT_COUNTER_WITH_CASH: 'PAY AT COUNTER WITH CASH',
  PAY_WITH_CREDIT_DEBIT: 'PAY HERE WITH CREDIT / CREDIT',
  NO_THANKS: 'NO, THANKS',
  ORDER_MORE_ITEMS: 'ORDER MORE ITEMS',
  PAY_WITH_CARD: 'PAY WITH CARD',
  VIEW_MY_ORDER: 'VIEW MY ORDER',
  ORDER_NAME: 'ORDER NAME',
  ORDER_FOR_HERE: 'ORDER FOR HERE',
  ORDER_TO_GO: 'ORDER TO-GO',
  REQUIRED: 'REQUIRED',
  ACCESSIBILITY: 'ACCESSIBILITY',
  NEED_ASSISTANCE: 'NEED ASSISTANCE?',
  SELECT_TIP: 'SELECT TIP',
  CONTINUE_WITH_PAYMENT: 'CONTINUE WITH PAYMENT',
  NAME_REQUIRED: 'NAME (required)',
  NAME_OPTIONAL: 'NAME (optional)',
  PHONE_OPTIONAL: 'PHONE (optional)',
  PHONE_REQUIRED: 'PHONE (required)',
  SCAN_TO_PAY: 'SCAN TO PAY',
  PAY_WITH_CASH: 'PAY WITH CASH',
  BACK_TO_TIP: 'BACK TO TIP',
  SEND_TEXT: 'SEND TEXT',
  SEND_EMAIL: 'SEND EMAIL',
  TEXT_IT_TO_ME: 'TEXT IT TO ME',
  EMAIL_IT_TO_ME: 'EMAIL IT TO ME',
  NO_THANK_YOU: 'NO, THANK YOU',
  ADD_TO_ORDER: 'ADD TO ORDER',
  RETURN_TO_MENU: 'RETURN TO MENU',
  ADD_NOTE: 'ADD NOTE',
  PAYMENT_DUE: 'PAYMENT DUE',
  TYPE_YOUR_NOTE: 'TYPE YOUR NOTE',
  PAY_AT_COUNTER: 'PAY AT COUNTER',

  // tableTop
  START_NEW_ORDER: 'START NEW ORDER',
  SPEED_ORDER: 'Speed Order',
  MAKE_PAYMENT: 'Make Payment',
  ORDER_ITEMS: 'Order Items',
  NO_ITEMS_ADDED: 'No Items Added',
  ASSIGN_TABLE: 'Assign Table',
  EDIT_ITEMS: 'Edit Items',
  UNSENT_ITEMS: 'UNSENT ITEMS',
  COUNTER_NEW_ORDER: 'NEW ORDER',

  // Fire Board
  CARD_TYPE: 'Type',
  REDACTED_CARD_NUMBER: 'Card #',
  SWIPE_CARD_HERE: 'Swipe Card Here',

  // ----------------------------------------------------------------------------

  NOTIFICATION_ID: 'notificationId',
  STORE_ID: 'storeId',
  NOTIFICATION_TYPE_ID: 'notificationTypeId',
  CATEGORY: 'category',
  SEVERITY: 'severity',
  ENTER_EMAIL_ID: 'Email Address',
  SHORT_NOTE: 'shortNote',
  ID: 'id',
  NUMBER: 'Number',
  EMPLOYEE_ID: 'employeeId',
  ITEM_AMOUNT: 'Item Amount',
  STATION_NAME: 'Station Name',
  IMAGE: 'image',
  NOW: 'Now',
  LATER: 'Later',
  CALL: 'Call',
  GET_OTP: 'Get Code',
  GO_BACK: 'GO BACK',
  GET_EMAIL_OTP: 'Get security code by Email',
  GET_MOBILE_OTP: 'Get security code by Text',
  VERIFY_YOUR_PHONE: 'Verify Your Phone',
  CHECK_IN: 'Check In',
  CHECK_IN_QR: 'Check in with a QR code',
  ENTER_TABLE_NUMBER: 'Enter My Table Number',
  SCAN_TABLE_CODE: 'Scan My Table Code',
  LEAVE_TABLE: 'Exit check',
  LOADING: 'Loading',
  RESEND_OTP: 'Resend Code',
  RESEND_IN: 'Resend in',
  SECONDS: 'seconds',
  BACK: 'BACK',
  SAVE_CHANGES: 'Save changes',
  YES_CONTINUE: 'Yes, continue',
  TRY_AGAIN: 'Try Again',
  SIGN_UP: 'SIGN UP',
  RESET_PASSWORD: 'Reset Password',
  SUBMITING: 'Submiting',
  SPLIT_EQUALY: 'Split Equaly',
  SELECT_BY_ITEMS: 'Select Items To Pay',
  SKIP: 'Skip',
  VERIFY: 'VERIFY',
  EMAIL_RECEIPT: 'EMAIL RECEIPT',
  YOUR_RECEIPT: 'Your Receipt',
  VIEW_RECEIPT: 'View Receipt',
  VIEW_DETAILS: 'View details',
  GENERATE_OTP: 'Generate Code',
  ADD_TIP: ' ADD TIP',
  CONFIRMATION: 'Confirmation',
  RESTAURANT: 'Restaurant',
  VEHICLE_DESCRIPTION: 'Vehicle Description',
  SPOT_NUMBER: 'Spot Number',
  I_AM_HERE: 'I AM HERE',
  CHECK_IN_WITH_CODE: 'Check in with a 7-digit code',
  ADD_A_TIP: 'Add a tip',
  NO_TIP: 'No Tip',
  CHECK_TOTAL_TIP: 'Your check total is',
  PLEASE_SELECT_TIP: 'Please select a Tip Amount',
  TIP_CONTINUE: 'CONTINUE WITH NEW TOTAL',
  CUSTOM_AMOUNT: 'CUSTOM AMOUNT',
  CUSTOM_PERCENT: 'CUSTOM PERCENT',
  OTHER_AMOUNT: 'Other Amount',
  OTHER_PERCENT: 'Other Percentage',

  // label
  ENTER_EMAILID_MESSAGE:
    'Please enter the email you use to sign in to OneDine.',
  SENDING_OTP: 'Sending',
  PLEASE_SELECT_OPTION: 'Please select one of the following options',

  // Form Label
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  NICK_NAME: 'Order Nickname',
  USER_NAME: 'User Name',
  EMAIL_ADDRESS: 'Email Address',
  ENTER_USERNAME_EMAIL: 'Username',
  ENTER_PASSWORD: 'Password',
  ENTER_OTP: 'Enter Code',
  CURRENT_PASSWORD: 'Current Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  COUNTRY_CODE: 'Country Code',
  ENTER_FIRST_NAME: 'First Name',
  ENTER_LAST_NAME: 'Last Name',
  ENTER_DESIRED_USERNAME: 'Username',
  ENTER_CONFIRM_PASSWORD: 'Confirm Password',
  ENTER_THE_OTP: 'Verification Code',
  CODE: 'Code',
  COMMENTS: 'Comments',
  BRANCH: 'Branch',
  PASSWORD: 'Password',
  SURNAME: 'Surname',
  CARD_HOLDER: 'Card Holder',
  TABLE_NUMBER: 'Table Number',
  MOBILE_NUMBER: 'Enter Your Phone Number',
  SPOT_CODE: '7-Digit Code',
  CARD_HOLDER_NAME: 'Card Holder Name',
  ADDRESS_TYPE: 'Address type',
  AGREED_CONDITION: 'I agree with the terms and conditions.',
  USE_DIFFERENT_NUMBER: 'Use a different number',
  REQUEST_DETAILS: 'Request Details',
  REQUEST_DATA: 'REQUEST DATA',
  DELETE_DATA: 'DELETE DATA',
  PROVIDE_FEEDBACK: 'PROVIDE FEEDBACK',
  ENTER_AMOUNT: 'Enter an amount',

  // Other_tips Placeholders
  ENTER_PERCENTAGE: 'Enter percentage',
  ENTER_TIP_AMOUNT: 'Enter tip amount',

  // Navigations Tab labels
  HOME: 'Check In',
  OFFERS_PROMOTIONS: 'Offers & Promotions',
  WALLET: 'Payments',
  // LOYALTY_ACCOUNTS: 'Loyalty Accounts',
  ORDER_HISTORY: 'Past Orders',
  SIGN_OUT: 'Sign Out',
  MY_DATA: 'My Data',
  PROFILE: 'Profile',
  PREFERENCES: 'Email / SMS Preferences',
  LOGOUT: 'Log Out',
  ACCOUNT: 'My Account',
  SUBSCRIPTION: 'Subscription',
  TABLE_ORDER: 'TABLE',
  TAB_ORDER: 'TAB',
  OTHER_ORDER: 'OTHER',

  // Others
  YOUR_CHECK_TOTAL: 'Your Check Total',

  // select item page
  SELECT_ALL: 'Select All',
  CONTINUE_WITH_SELECTION: 'Continue with selection',
  SELECT_ALL_ITEMS_AND_CONTINUE: 'Select all items and continue',
  PAY_SELECTED: 'Pay Selected',
  PAY_ALL: 'Pay all',
  // TOTAL_AMOUNT: 'Total Amount',
  INCLUDING_TIP_NEW_TOTAL: 'Including tip, pay a total of',
  ACTIONS: 'Actions',
  EXPIRES_ON: 'Expires on:',
  READ_ONLY: '(read only)',
  EACH: ' each',
  YOUR_CHECK_SPLIT: 'Your check has been splited among ',
  MEMBERS: 'members with ',
  YOUR_ITEMS_CHECK_LIST: 'Your items check list',
  TOTALS: 'TOTAL',
  CHECK_TOTAL: 'Check total',
  STORE_SELECTION: 'Store Selection',
  SENSOR_ASSIGNMENT: 'Sensor Assignment',
  MANAGE: 'Manage',
  SENSOR: 'Sensor',
  TOO_FAST: 'Too Fast',
  TOO_SLOW: 'Too Slow',
  JUST_RIGHT: 'Just Right',
  TOTAL_AMOUNT: 'TOTAL',
  VALUE: 'Value',

  // Speed order

  ENTER_PHONE_OPTIONAL: 'Enter Phone (optional)',
  ENTER_PHONE_NUMBER: 'Enter Phone',
  FINALIZE_ORDER: 'Finalize Order',

  // Payment screen
  OFFERS: 'Offers',
  REWARDS: 'rewards',
  ROUND_UP: 'Round up',
  DELIVERY_FEE: 'Delivery fee',
  PICKUP: 'Pickup',
  REFRESH: 'Refresh',
  RETRY_PAYMENT: 'Retry Payment',
  SUBMIT_ORDER: 'Submit Order',
  COUPON: 'Coupon',
  NO_CHECK_AVAILABLE: 'Check not available',
  QR_PAY_FROM_PHONE: 'QR pay from phone',
  ESTIMATED_POINTS_EARNED: 'Estimated points earned',
  CHANGE: 'Change',
  FINALIZE: 'Finalize',
  DRAWER_OPEN: 'DRAWER OPEN',
  DRAWER_CLOSE: 'DRAWER CLOSED',
  AMOUNT_ENTERED: 'Amount Entered',
  PENDING_BALANCE: 'Pending Balance',
  CURRENT_BALANCE: 'Current Balance',
  AMOUNT_OWED: 'Amount Owed',
  AMOUNT_DUE: 'Due Amount',
  NOTHING_DUE_OWED: 'Nothing due or owed',
  SERVER_CASHOUT_REPORT: 'Server Cash Out Report',
  CASHIER_CASHOUT_REPORT: 'Cashier Cash Out Report',
  AMOUNT_OVER: 'Amount Over',
  AMOUNT_SHORT: 'Amount Short',
  NOTHING_OVER_SHORT: 'Nothing Over or Short',
  CASHOUT_SUMMARY: 'Cash Out Summary',
  ITEMS_LIST: 'Item',
  ITEMS_SEAT: 'Seat',
  AMOUNT: 'Amount',

  COLLECTED: 'Collected',
  PAPER: 'Print Receipt',
  NONE: 'No Receipt',
  CHANGE_PAYMENT_TYPE: 'Change Payment',
  BANK_AMOUNT: 'Bank Amount',
  PAID_IN_AMOUNT: 'Paid In Amount',
  PAID_OUT_AMOUNT: 'Paid Out Amount',
  CASH_DROP_AMOUNT: 'Cash Drop Amount',
  CASH_PAYMENT_AMOUNT: 'Cash Payment Amount',
  CREDIT_CARD_PAYMENT_AMOUNT: 'Credit Card Payment Amount',
  CREDIT_CARD_TIP_AMOUNT: 'Credit Card Tip Amount',
  PENDING_CASHOUT_AMOUNT: 'Pending Cash Out Amount',
  OVER_SHORT_AMOUNT: 'Over Short Amount',
  TIP_OUT: 'Tip Out',
  CASH_OUT_DEPOSIT_AMOUNT: 'Cash Out',
  SUGGESTED_TIP_MSG:
    '*Suggested tip is calculated on check amount before any applied discounts and after sales tax has been added',

  CLEAR_SPLITS: 'CLEAR SPLITS',
  SPLIT_BY_SEATS: 'SPLIT BY SEATS',
  SPLIT_BY_SELECTED_SEATS: 'SPLIT BY SELECTED SEATS',
  TOTAL_DUE: 'Total Due',
  OTHER_PAYMENT_OPTIONS: 'OTHER PAYMENT OPTIONS',
  SPLIT_BY: 'SPLIT BY',

  // Check Number screen
  CHECK_NUMBER: 'Check Number',
  FULL_CHECK: 'Full Check',
  SPLIT_ITEMS: 'Select Items',
  PAY_MY_ITEMS: 'Pay My Items',
  PAY_BY_GUEST: 'Pay By Guest',
  DINE_IN: 'Dine In',
  DC_NAME_OF_THIS_ORDER: 'Enter a name for this order',
  CASH_OUT: 'Cash Out',
  CASH_IN: 'Cash In',
  CASH_IN_CANCEL: 'Cancel',

  // Footer Screens
  FOOTER_HOME: 'Home',
  FOOTER_MENUS: 'Menus',
  FOOTER_ORDERS: 'Order',
  FOOTER_MY_BAG: 'My Bag',
  FOOTER_MORE: 'More',
  FAVOURITE: 'Favorite',
  BROWSE: 'Browse',
  FOOTER_STORE: 'Store',

  // HOME SCREEN, REFILL, DAISY CHAIN
  CLICKTOPAYLABEL: 'CLICK TO PAY',
  ADD_ITEMS_TO_REFILL: 'Add items to refill',
  REFILL: 'Refill',
  REFILL_EMPTY_CART_MSG:
    'Sorry, your order does not contain any items that are eligible for a refill',

  // DAISY CHAIN BUTTONS
  DAISY_FIRST_PERSON_YES: 'Yes, I’m the only one',
  DAISY_FIRST_PERSON_NO: 'No, I’m not the only one',
  DAISY_LAST_PERSON_YES: 'Yes, I’m the last one',
  DAISY_LAST_PERSON_NO: 'No, I’m not the last one',

  // Walkup Screen
  WHAT_WOULD_YOU_LIKE: 'What would you like to today',
  NO_OF_GUEST: 'Number of Guest In Your Party',
  HOW_MANY_CHILDREN: 'Of your guest,How Many are Children?',
  CHECK_AVAILABILITY: 'Check Availability',
  ADD_TO_WAIT_LIST: 'Add to Wait List',

  // Spot Screens
  ENTER_NAME_BELOW: 'Enter your name below',

  // Up sell
  MAY_WE_SUGGEST: 'May we suggest?',

  // Multicart

  // Pay Later

  // Other tips messages
  TIP_THIS_AMOUNT: 'Tip this amount:',

  // Tips Home
  CARD_CHARGED: 'If you proceed, your card will be charged.',
  PROCEED_ORDER_PLACED: 'If you proceed, your order will be placed.',
  DC_ORDER_MSG: 'Are you the last person to add to this order?',
  DC_ORDER_PLACE_MSG: 'Are you the only person sending an order right now?',
  HAS_PLACED_ORDER: 'has placed an order.',
  HAVE_PLACED_ORDER: 'have placed their orders.',
  HOW_MANY_PPL: 'Please select how many people will split this check:',
  RECEIPT_OPTION: 'Choose a receipt option',
  ADD_CARD: 'Add Card',
  REMOVE_CARD: 'Remove Card',
  SAVE_CARD: 'Save card',

  // Coupon Labels
  REMOVE_COUPON: 'Remove Coupon',
  APPLY_COUPON: 'Apply Coupon',

  // Coupon Screen
  CS_SCAN_QR_CODE: 'SCAN QR CODE',
  CS_APPLY_CODE: 'APPLY CODE',
  CS_CANCEL: 'CANCEL',
  CS_SCAN_BAR_CODE: 'SCAN BARCODE',

  // Charity
  CHARITY: 'Charity',
  APPLY_DONATION: 'Apply Donation',
  SKIP_DONATION: 'Skip Donation',
  CUSTOM: 'Custom',

  // LOYALTY_LOGIN: 'Login or Register for Rewards',

  // Pre auth
  HOLD: 'Hold',
  AUTHORIZE_CARD: 'Authorize card',
  I_AGREE: 'I Agree',
  KEEP_IT_OPEN: 'Keep it open',
  CONTINUE_AS_GUEST: 'Continue as Guest',

  // Menu Item Badge

  // Item Not Found
  ITEM_NOT_FOUND:
    'Search item not found. Please select a different item or contact the restaurant.',
  MENU_ITEM_NOT_ITEM:
    'Menu is currently not available. Please select a different menu or contact the restaurant.',

  // LOYALTY_WALLET_NAME: 'Name',
  // LOYALTY_UPDATE_NAME: 'Update Name',

  APARTMENT_NUMBER: 'Apartment or suite number (optional)',

  // Table Grouping Order
  JOIN_CHECK_AND_CONTINUE: 'Join check and continue',
  START_A_NEW_CHECK: 'Start a new check',
  JOIN_EXISTING_CHECK: 'Join existing check',
  JOIN_PARTY_WITH: 'Join a party with',

  // Address Management
  WALLET_ADDRESS: 'Address Book',
  WALLET_ADDRESS_NAME: 'Name',
  WALLET_LOOK_UP_ADDRESS: 'Lookup Address',
  WALLET_ADDRESS_UPDATE: 'Update',
  CART_BUTTON: 'SUBMIT ORDER',
  IMMEDIATE_ADD_TO_BAG: 'Add to Bag',
  CHECKOUT_DELIVER_TO: 'Deliver TO',
  CHECKOUT_SPOT_NUMBER: 'Spot Number',
  DATE: 'Date',
  PAY_WITH_STRIPE: 'PAY WITH CREDIT CARD',
  PAY_WITH_SPREEDLY: 'Pay with Spreedly',
  ITEM_SEARCH: 'Search Item',
  PICK_UP_TO: 'Pick up to',
  PICK_UP: 'Pick Up',
  OPTIONAL: 'optional',

  SELECT_DELIVERY_TIME: 'Select Delivery Time',
  SELECT_DELIVERY_DATE: 'Select Delivery Date',
  SELECT_PICK_UP_TIME: 'Select Pickup Time',
  SELECT_PICK_UP_DATE: 'Select Pickup Date',
  EDIT_ONL_ORDERS_YES: 'YES',
  EDIT_ONL_ORDERS_NO: 'NO',
  EDIT_ONL_ORDERS_OK: 'OK',
  EDIT_CU_ORDERS_SPOT_NUMBER: 'Spot Number',
  EDIT_CU_ORDERS_NAME: 'Name',
  DESKTOP_LOGIN: 'Login',
  DRIVE_THRU: 'Drive thru',
  TIP_ROUNDUP: 'Use tip to round up total',

  // Button Text for order page
  PAID_AMOUNT: 'PAID AMOUNT',

  // Others
  STAY: 'Stay',
  LOG_OUT: 'Logout',
  CANCEL_ORDER: 'CANCEL ORDER',

  // Cubby
  READY_TO_PICKUP: 'ORDERS READY FOR PICKUP',
  CUBBY: 'CUBBY#',

  // OrderUp
  PREPARING: 'PREPARING',
  READY: 'READY',
  SEE_COUNTER: 'SEE COUNTER',
  ORDER_STATUS: 'ORDER STATUS',
  NO_READY_PICK_UP_ORDERS: 'NO ORDERS READY FOR PICKUP',
  CONNECTING_TO_NEWTWORK: 'CONNECTING TO NETWORK',
  SOCKET_STATUS: 'STATUS',
  LAST_UPDATED_TIME: 'LAST UPDATE',
  TOTAL_CHECKS: 'TOTAL CHECKS',
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',

  // kds
  ITEM: 'ITEM',
  LAST_HOUR: 'LAST HOUR',
  PAGE: 'PAGE',
  VIEW_ALL: 'View All',
  KDS_SELECT: 'SELECT',
  KDS_DROP: 'DROP',
  KDS_PRIORITIZE: 'Prioritize',
  KDS_SELECTED: 'Selected',
  KDS_DROP_CONTINUE: 'Continue',
  KDS_DROP_CANCEL: 'Cancel',
  KDS_MOVE_HERE: 'Move Here',

  KDS_LAYOUT: 'Layout',
  KDS_DUPLICATE: 'Duplicate',
  KDS_SUBMIT: 'Submit',
  KDS_BUMP_SELECTED: 'Bump Selected',
  KDS_BUMP: 'Bump',
  KDS_RECEIPE: 'Receipe',
  KDS_DRAG: 'Drag',
  KDS_RUSH: 'Rush',
  // payment terminal
  EMPLOYEE_NAME: 'Emp',
  CHECK_NUM: 'Check Num',

  // survey
  SURVEY_YES: 'Yes',
  SURVEY_NO: 'No',


  //Gamecard
  ADD_ON: 'Add On',
  PRICE: 'Price',
  STATUS: 'Status',
  MESSAGE: 'Message',
  PROCESS: 'Processed',
  CARD_BALANCE: 'Balance',
  TRANSACTIONS: 'Transactions',
  SHOW: 'Show All',
  CARDNAME: 'Card Name',
  CARDNUMBER: 'Card Number',
  GAMECARDSWIPE: 'Swipe',
  SENDANDACTIVATE: 'Send And Activate',
  SENDANDPAY: 'Send And Pay',

  //syncDatamsg
  CHECK_MEG: 'Check Has Been Modified',
  CHECK_SERVER: 'Please contact a server to complete payment.',
  PAYMENT_MEG: 'Payment not authorized for the full amount',
  PAYMENT_SERVER: 'Please contact a server to complete payment.',
  GIFT_CARD_ACTIVATION_MESSAGE:
    'Please select how you would like to receive your activation slip for your Gift Card(s)',
  GIFTCARD_EMAIL_RECEIPT: 'Email',

  // Payment Methods
  CREDIT_CARD_PAY: 'CREDIT CARD',
  CASH_PAY: 'CASH',
  GIFT_CARD_PAY: 'GIFT_CARD',
  DEFAULT_PAY: '',

  //CHECK PRESENTER
  CHECK_PRESENTER_PAY: 'PAY',
  CHECK_PRESENTER_PAID: 'PAID',
  CHECK_PRESENTER_NEXT_CHECK: 'NEXT',
  CHECK_PRESENTER_PREVIOUS_CHECK: 'PREVIOUS',
  CHECK_PRESENTER_LOYALTY: 'Loyalty',

  //Landing Page
  LS_BACK: 'Back',
  LS_CLEAR_SPLITS: 'Clear Splits',
  LS_SPLIT_BY_SEATS: 'Split By Seats',
  LS_PAY_REMAINING_SEATS: 'PAY REMAINING SEATS',
  LS_SPLIT_BY_SELECTED_SEATS: 'Split By Selected Seats',
  LS_PAY_REMAINING_SELECTED_SEATS: 'PAY REMAINING SELECTED SEATS',
  LS_SPLIT_EVENLY: 'Split Evenly',
  LS_PAY_REMAINING_SPLITS: 'PAY REMAINING SPLITS',
  LS_PAY_FULL_CHECK: 'Pay Full Check',
  LS_PAY_BALANCE: 'Pay Balance',
  LS_REWARDS : 'Rewards',
  LSO_CONTINUE : 'Continue',
  LS_BACK_TO_CHECK : 'Back to Check',
  LS_REWARDS_VALUE : ' Rewards Value',
  LS_DONE: 'Done',
  LS_CANCEL: 'Cancel',
  LS_AVAILABLE_OFFERS: 'Available Offers',
  LS_APPLY_OFFERS: 'Apply Offer',
  LS_AVAILABLE_REWARDS: 'Available Rewards',
  LS_REDEEM: 'Redeem',
  LS_REWARD_REDEMPTION: 'Reward Redemption',
  LS_AMOUNT_TO_REDEEM: 'Amount To Redeem',
  LS_YES : 'Yes',
  LS_NO : 'No',

  //Payment Confirmation screen
  PC_PAYMENT_SUCCESSFUL: 'PAYMENT SUCCESSFUL',
  PC_PAYMENT_COMPLETE: 'PAYMENT COMPLETE',
  PC_DUE: 'DUE',
  PC_DETAILS: 'Details',
  PC_CONTINUE: 'CONTINUE',

  //Partial Tip Payment Screen
  PPES_CHECK: 'CHECK',
  PPES_TIP: 'TIP',
  PPES_TOTAL: 'TOTAL',
  PPES_TIP_COLLECTED: 'TIP COLLECTED',
  PPES_TIP_DUE: 'TIP DUE',
  PPES_UNCOLLECTED_TIP: 'UNCOLLECTED TIP',
  PPES_PAYMENT_PARTIALLY_APPROVED: 'Payment Partially Approved',
  PPES_PAYMENT_NOT_PROCESSED: 'Payment Not Processed!',
  PPES_CHECK_AMOUNT: 'CHECK AMOUNT',
  PPES_AUTHORIZED: 'AUTHORIZED',
  PPES_BALANCE_DUE: 'BALANCE DUE',
  PPES_PAY_BALANCE: 'PAY BALANCE',
  PPES_RETRY: 'RETRY',

  //Receipt screen check details
  RECEIPT_DISCOUNT: 'Discount',
  RECEIPT_COUPON_KEY: 'Coupon',
  RECEIPT_OFFER_KEY: 'Offer',
  RECEIPT_SUBTOTAL: 'Subtotal',
  RECEIPT_TOTAL: 'Total',
  RECEIPT_TAX: 'Tax',
  RECEIPT_SERVICE_CHARGE: 'Service Charge',
  RECEIPT_TIP: 'Tip',
  RECEIPT_PAID: 'Paid',
  RECEIPT_GIFT_CARD: 'Gift card',
  RECEIPT_DUE: 'Due',
  RECEIPT_PAID_TIPS: 'Paid Tip',
  RECEIPT_UNPAID_TIP: 'Unpaid Tip',
  RECEIPT_PAYMENT: 'Payment',
  RECEIPT_ITEMS: 'Items',
  RECEIPT_TOTAL_DUE: 'Total Due',
  RECEIPT_TOTAL_PAID: 'Total Paid',
  RECEIPT_TOTAL_AMONUT: 'Total Amount',
  RECEIPT_ITEMIZED_PAYMENT: 'Payment',
  MY_LOYALTY: 'Loyalty',
  RECEIPT_ROUNDING: 'Rounding',

  // Employee Initiate Payment Screen
  EPS_PAY: 'PAY',
  EPS_CANCEL: 'CANCEL',
  EPS_APPLY: 'APPLY',
  EPS_LOGIN: 'LOGIN',
  EPS_SELECT_PAYMENT_METHOD: 'SELECT PAYMENT METHOD',
  EPS_PAY_CASH: 'PAY CASH',
  EPS_PAY_GIFT_CARD: 'PAY GIFT CARD',
  EPS_PAY_CREDIT_CARD: 'PAY CREDIT CARD',
  EPS_CREDIT_CARD: 'CREDIT CARD',
  EPS_GIFT_CARD: 'GIFT CARD',
  EPS_CASH: 'CASH',
  EPS_AMOUNT_COLLECTED: 'AMOUNT COLLECTED',
  EPS_CHANGE: 'CHANGE',
  EPS_PAYMENT: 'PAYMENT',
  EPS_COLLECTED: 'COLLECTED',
  EPS_CREDIT_CARD_PAYMENT: 'Credit Card Payment',
  EPS_REDEEM: 'REDEEMED',
  EPS_BALANCE: 'BALANCE',
  EPS_DUE: 'DUE',
  EPS_NO_PAYEMNTS: 'No Payments',
  EPS_SELECT_A_PAYMENT_METHOD: 'Select a payment method from above',
  EPS_PAY_AT_COUNTER: 'PAY AT COUNTER',
  EPS_PAY_LATER: 'PAY LATER',
  EPS_ITEMIZED_CHECK: 'ITEMIZED CHECK',
  EPS_ROUNDING: 'Rounding',

  //TIP SCREEN
  TIP_CHECKTOTAL: 'Your Check Total Is',
  TIP_SELECT: 'Please select a tip',
  TIP_OTHER: 'Other Amount',
  TIP_NO_TIP: 'No Tip',
  TIP_AMOUNT: 'Amount',
  TIP_PERCENT: 'Percent',
  TIP: 'Tip',
  TIP_NO: 'NO',
  TIP_YES: 'YES',
  TIP_VALIDATION_MESSAGE: 'Select tips or enter a valid tip amount or 0',
  TIP_HAS_AUTO_GRATUITY_SELECT: 'Please select additional tip',
  TIP_HAS_AUTO_GRATUITY_NO_TIP: 'No additional tip',
  TIP_ENTER: 'Please enter a tip',
  CHANGE_TIP: 'Change Tip',
  TIPS_CONTINUE: 'Continue',

  //SPLIT BY SELECTED SEATS
  SBSS_CREATE_CHECK: 'Create Check',
  SBSS_SEATS_INC_DEC: 'Seat',
  SBSS_CHECK: 'Check',
  SBSS_SAVE: 'SAVE',
  SBSS_BACK: 'BACK',
  SBSS_CLICK_TO_PAY: 'CLICK TO PAY',
  SBSS_MOVE: 'MOVE',
  SBSS_SUBMIT: 'Submit',
  SBSS_CANCEL: 'Cancel',
  SBSS_ALL_CHECKS: 'All Checks',
  SBSS_OK: 'OK',
  SBSS_LOYALTY: 'Loyalty',

  //SPLIT BY SEATS
  SBS_SEATS_INC_DEC: 'SEATS + /-',
  SBS_CHECK: 'Check',
  SBS_SAVE: 'SAVE',
  SBS_BACK: 'BACK',
  SBS_CLICK_TO_PAY: 'CLICK TO PAY',
  SBS_MOVE: 'MOVE',
  SBS_SUBMIT: 'Submit',
  SBS_CANCEL: 'Cancel',
  ITEMS: 'Items',
  QTY: 'Qty',
  CHECK_NAME: 'Check Name',
  SBS_OK: 'OK',
  SBS_LOYALTY: 'Loyalty',

  // Gift Card Screen
  GS_CLICK_TO_SWIPE_CARD: 'CLICK TO SWIPE CARD',
  GS_APPLY: 'APPLY',
  GS_CANCEL: 'CANCEL',
  GS_CLICK_TO_ENTER_CARD_NUMBER: 'Click To Enter Card Number',
  GS_CLICK_TO_ENTER_SECURITY_CODE: 'Click To Enter Security Code',
  GS_ORIGINAL_BALANCE: 'Original Balance',
  GS_REDEEMED_AMOUNT: 'Redeemed Amount',
  GS_REMAINING_BALANCE: 'Remaining Balance',
  GS_DONT_USE: "DON'T USE",
  GS_REDEEM: 'REDEEM',
  GS_ADD_GIFT_CARD: 'ADD A GIFT CARD',
  GS_ADD_ANOTHER_GIFT_CARD: 'ADD ANOTHER GIFT CARD',
  GS_BACK: 'BACK',
  GS_NEXT: 'NEXT',

  //Loyalty screen
  LS_PHONE: 'PHONE',
  LS_EMAIL: 'EMAIL',
  LS_ACCOUNT: 'ACCOUNT #',
  LS_SIGN_IN_TO_LOYALTY: 'SIGN IN TO LOYALTY',
  LS_JOIN_LOYALTY_PROGRAM: 'Would you like to join our loyalty program today?',
  LS_JOIN_NOW: 'JOIN NOW',
  LS_ALREADY_A_MEMBER: 'ALREADY A MEMBER',
  LS_NOT_NOW: 'NOT NOW',
  LS_SIGN_UP_TO_LOYALTY: 'SIGN UP TO LOYALTY',
  LS_JOIN_TODAY: 'How would you like to join today?',
  LS_SIGN_UP: 'Sign Up',
  LS_SIGN_IN_TODAY: 'How would you like to sign in today?',
  LS_SIGN_IN: 'Sign In',
  LS_CANCEL: 'CANCEL',
  LS_CONTINUE: 'CONTINUE',
  LS_WELCOME_BACK: 'Welcome back!',
  LS_VALUE: 'Value',
  LS_QUANTITY: 'Quantity',
  LS_SKIP_OFFER: 'SKIP OFFER',
  LS_USE_OFFER: 'USE OFFER',
  LS_CHANGE_ACCOUNT: 'Change Account',
  LS_SIGN_UP_SUCCESS_TEXT:
    'You have successfully signed up to the loyalty program!',
  LOYALTY_CLOSE: 'CLOSE',
  LS_CLEAR_ACCOUNT: 'Clear Account',

  // Receipt screen
  RS_NO_RECEIPT: 'No Receipt',
  RS_DUE: 'Due',
  RS_NEED_A_RECEIPT: 'Need a Receipt?',
  RS_YOU_ARE_ALL_DONE: "You're all done!",
  RS_NO: 'No',
  RS_YES: 'Yes',
  RS_ZIPCODE: 'Enter Zipcode',
  RS_BALANCE_AMOUNT: 'Balance Amount',
  RS_LOYALTY: 'Loyalty',

  RECEIPT_PRINT_STATUS: "Status",
  RECEIPT_SELECT: "Select",
  TRANSFER_TAB: 'Transfer Tab',
  CHK_RS_RECEIPT_SCREEN: 'Receipt Screen',

  //Search Modal
  SEARCH_ITEM: 'Search Items',

  PRE_AUTH: 'Pre Auth',
  MERGE_CHECK_TITLE: 'Select check(s) to merge',
  MORE_FUNCTION_TITLE: 'More Function',
  ADD_SEAT_TITLE: 'Select seat to add seat',
  DELETE_SEAT_TITLE: 'Delete Seat',
  OPEN_PRICE: 'Open Price',

  // Notification screen
  NS_NOTIFICATIONS: 'Notifications',
  NS_CLOSE: 'Close',
  NS_DISMISS: 'Dismiss',
  NS_ACKNOWLEDGED: 'Acknowledge',

  // Open Tab/Table
  ADD_TAB: 'Add Tab',
  ADD_TABLE: 'Add Table',

  ACTIVATE_GIFT_CARDS_TO_PAY: 'Activate the gift card(s) to pay.',
  OT_CONTINUE: 'Continue',

  GAME_CARD_SWIPE_TO_ACTIVATE: "Swipe the card(s) to activate",
  REPOST_OK: 'OK',

  SPLIT_BUTTON_DELETE: "Delete Seat",

  // Split Evenly
  SE_SELECT_LOYALTY_ACCOUNT_HEADER: "Select Loyalty Account",
  SE_SELECT_LOYALTY_ACCOUNT: "Please select loyalty account(s)",
  SE_ACCOUNT_SELECT: "Number of accounts to select",
  SE_CANCEL: 'Cancel',
  SE_OK: "OK",
  SE_ERR_MUST_SELECT: "You must select",
  SE_ERR_LOYALTY_ACCOUNT: "loyalty accounts to proceed",

  // Payment full check
  PF_SELECT_LOYALTY_ACCOUNT_HEADER: "Select Loyalty Account",
  PF_SELECT_LOYALTY_ACCOUNT: "Please select loyalty account(s)",
  PF_ACCOUNT_SELECT: "Number of accounts to select",
  PF_CANCEL: 'Cancel',
  PF_OK: "Ok",
  PF_ERR_LOYALTY_ACCOUNT: "PLease select a loyalty account",
  PF_LOYALTY: 'Loyalty',

  // Split by selected seats
  SSE_SELECT_LOYALTY_ACCOUNT_HEADER: "Select Loyalty Account",
  SSE_SELECT_LOYALTY_ACCOUNT: "Please select loyalty account(s)",
  SSE_CANCEL: 'Cancel',
  SSE_OK: "OK",
  SSE_ERR_LOYALTY_ACCOUNT: "PLease select a loyalty account",


    //Order Loyalty screen
  OLS_LOYALTY_PGM_HEADER: "Loyalty Program",
  OLS_JOIN_NOW: 'JOIN NOW',
  OLS_ALREADY_A_MEMBER: 'ALREADY A MEMBER',
  OLS_NOT_NOW: 'NOT NOW',
  OLS_PHONE: 'PHONE',
  OLS_EMAIL: 'EMAIL',
  OLS_SIGN_IN_TO_LOYALTY: 'SIGN IN TO LOYALTY',
  OLS_SIGN_UP_TO_LOYALTY: 'SIGN UP TO LOYALTY',
  OLS_SIGN_UP: 'Sign Up',
  OLS_SIGN_IN: 'Sign In',
  OLS_CANCEL: 'CANCEL',
  OLS_CONTINUE: 'CONTINUE',
  OLS_WELCOME_BACK: 'Welcome back!',
  OLS_OFFERS: ' Available Offers',
  OLS_VALUE: 'Value',
  OLS_QUANTITY: 'Quantity',
  OLS_SKIP_OFFER: 'Skip Offer',
  OLS_USE_OFFER: 'Use Offer',
  OLS_CHANGE_ACCOUNT: 'Change Account',
  OLS_CLEAR_ACCOUNT: 'Clear Account',
  OLS_LOYALTY_CLOSE: 'CLOSE',
  OLS_NO_OFFERS: 'NO OFFERS',
  OLS_AVAILABLE_OFFERS: 'Avaialble Offers',


  //Order Loyalty Landing Page
  OLLS_LOYALTY_SIGN_UP: "Loyalty Sign Up",
  OLLS_DONE: 'Done',
  OLLS_VIEW_OFFERS: 'View Offers',
  OLLS_REMOVE: 'Remove',
  OLLS_SIGN_UP: 'Sign Up',
  OLLS_SIGN_IN: 'Sign In',
  OLLS_NO_OFFERS: 'No Offers Available',
  ADD_LOYALTY: 'Add Loyalty',

  // Modifires Note label
  ITEM_NOTE: 'Item Note',
  MODIFIER_ITEM_NOTE: 'Modifier Item Note',

  // Available Loyalty Offers
  ALO_DONE: 'Done',
  ALO_CANCEL: 'Cancel',

  // Hamburger Loyalty Balance
  LB_LOYALTY_BALANCE : 'Loyalty Balance',
  LB_SIGN_IN_TO_LOYALTY : 'Sign in to loyalty',
  LB_PHONE : 'PHONE',
  LB_EMAIL : 'EMAIL',
  LB_CANCEL : 'CANCEL',
  LB_SIGN_IN : 'Sign In',
  LB_CONTINUE : 'CONTINUE',
  LB_AVAILABLE_OFFERS : 'Available Offers',
  LB_CLOSE : 'CLOSE',
  LB_LOYALTY_PROGRAM : 'Loyalty Program',
  LB_JOIN_NOW : 'JOIN NOW',
  LB_ALREADY_A_MEMBER : 'ALREADY A MEMBER',
  LB_NOT_NOW : 'NOT NOW',
  LB_SIGN_UP_TO_LOYALTY : 'Sign up to loyalty',
  LB_SIGN_UP : 'Sign Up',
  LB_NO_OFFERS : 'No Offers',

  CND_ORDER_ITEMS: 'Order Items',
  CND_PAY: 'Pay',
  CND_HEADER: 'Select Options',

  DT_CANCEL: "Cancel",
  DT_CONTINUE: "Continue",
  DT_ENTER_NAME: "Enter name",

  // attach party
  ATP_ATTACH_TO_PARTY: "Attach to Party",
  ATP_EVENT_NUMBER: "Event Number",
  ATP_EVENT_NAME: 'Event Name',
  ATP_START_DATE: 'Start Date',
  ATP_START_TIME: 'Start Time',
  ATP_SELECT: 'Select',

  // GiftCardScreen
  GIFT_CARD_PAYMENT : 'Payment',
  ACTIVATE_GIFT_CARD: "Activate gift card",
  GIFT_CARD_BACK_TO_CHECK: "Back to check",

  // Cash out
  CO_CANCEL: 'Cancel',

  // Call center
  CC_SELECT_PAYMENT_METHOD: 'SELECT PAYMENT METHOD',
  CC_SEND_AND_PAY_AT_RESTAURANT: 'Send & Pay At Restaurant',
  CC_TEXT_TO_PAY: 'Text To Pay',
  CC_YES: 'Yes',
  CC_NO: 'No',

  // ToGo
  TG_SELECT_PAYMENT_METHOD: 'SELECT PAYMENT METHOD',
  TG_SEND_AND_PAY_AT_RESTAURANT: 'Send & Pay At Restaurant',
  TG_TEXT_TO_PAY: 'Text To Pay',
  TG_YES: 'Yes',
  TG_NO: 'No',
  TG_TOGO:'To Go',
  TG_PAY_LATER: 'Pay Later',

  //Speed Order
  SPO_KEEP_IT_OPEN: 'KEEP IT OPEN',
  SPO_NO: 'NO',
  SPO_YES: 'YES'
}
